module.exports = __webpack_public_path__ + "img/agriculture.c901a8dd.jpg";